import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  /* 🎨 Define Brand Colors */
  :root {
    --main-orange: #FF7C24;
    --main-black: #232830;
    --main-white: #FFFFFF;

    /* 🖋 Typography - Font Family */
    --font-primary: 'Nunito Sans', sans-serif;

    /* 🔠 Display Styles */
    --display-large: 34px;
    --display-medium: 28px;
    --display-small: 24px;

    /* 🔠 Title Styles */
    --title1-size: 22px;
    --title2-size: 20px;
    --title3-size: 18px;

    /* 🔠 Body Text Styles */
    --headline-size: 17px;
    --body-size: 17px;
    --callout-size: 16px;
    --subhead-size: 15px;
    --footnote-size: 13px;
    --caption1-size: 12px;
    --caption2-size: 10px;

    /* 🔠 Button & Form Styles */
    --button-text-size: 16px;
    --field-label-size: 16px;
  }

  /* 📄 Global Reset & Defaults */
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  /* 🌍 Body Styling */
  body {
    font-family: var(--font-primary);
    color: var(--main-black);
    background-color: var(--main-white);
    line-height: 1.6;
  }

  /* 🏷️ Rounded Text Elements */
  h1, h2, h3, h4, h5, h6, p, a, button, input, textarea {
    border-radius: 12px; /* Smoother rounded text */
    padding: 8px 14px; /* Adds space for rounded effect */
  }

  /* 🏷️ Headings */
  h1 {
    font-size: var(--display-large);
    font-weight: bold;
    color: var(--main-orange);
    border-radius: 14px; /* More rounded feel */
    padding: 10px;
  }

  h2 {
    font-size: var(--display-medium);
    font-weight: bold;
    color: var(--main-orange);
    border-radius: 12px;
    padding: 8px;
  }

  h3 {
    font-size: var(--display-small);
    font-weight: bold;
    color: var(--main-black);
    border-radius: 10px;
    padding: 6px;
  }

  /* 📝 Paragraphs & Links */
  p {
    font-size: var(--body-size);
    font-weight: 400;
    line-height: 1.5;
    color: var(--main-black);
    border-radius: 10px;
    padding: 6px 12px;
    background-color: rgba(255, 124, 36, 0.1); /* Light orange tint */
  }

  a {
    font-size: var(--body-size);
    text-decoration: none;
    color: var(--main-orange);
    font-weight: 600;
    transition: all 0.3s ease;
    border-radius: 10px; /* Rounded links */
    padding: 6px 10px;
  }

  a:hover {
    text-decoration: underline;
    color: var(--main-black);
    background-color: rgba(255, 124, 36, 0.15);
    border-radius: 12px;
  }

  /* 🎯 Buttons */
  button {
    font-size: var(--button-text-size);
    font-weight: bold;
    color: var(--main-white);
    background-color: var(--main-orange);
    border: none;
    padding: 14px 28px;
    border-radius: 20px; /* Highly rounded buttons */
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 2px 4px 10px rgba(0, 0, 0, 0.1);
  }

  button:hover {
    background-color: var(--main-black);
  }

  /* 🏗️ Forms & Inputs */
  label {
    font-size: var(--field-label-size);
    font-weight: 400;
    color: var(--main-black);
    display: block;
    border-radius: 8px;
    padding: 4px;
  }

  input, textarea {
    font-size: var(--field-label-size);
    font-weight: 400;
    padding: 14px;
    border: 1px solid var(--main-black);
    border-radius: 16px; /* More rounded input fields */
    width: 100%;
    margin-top: 5px;
    transition: border-color 0.3s ease, box-shadow 0.3s ease;
    background-color: rgba(35, 40, 48, 0.03);
  }

  input:focus, textarea:focus {
    outline: none;
    border-color: var(--main-orange);
    box-shadow: 0px 0px 8px rgba(255, 124, 36, 0.4);
  }

  /* 🎨 Rounded Containers */
  .rounded-container {
    border-radius: 16px;
    padding: 20px;
    background-color: rgba(35, 40, 48, 0.05);
    box-shadow: 2px 4px 10px rgba(0, 0, 0, 0.1);
  }

  /* 🛠 Utility Classes */
  .text-center {
    text-align: center;
  }

  .text-bold {
    font-weight: bold;
  }

  .rounded-text {
    border-radius: 12px;
    padding: 6px 10px;
    background-color: rgba(255, 124, 36, 0.1);
  }
`;

export default GlobalStyles;